/** Card-sized answer; overflow moves to extraInfo (bulk AI + manual JSON). */

export const BULK_ANSWER_MAX_CHARS = 900;
export const BULK_ANSWER_MAX_NUMBERED_SECTIONS = 3;

function findNumberedSectionStarts(text) {
  const starts = [];
  const re = /(?:^|\s)(\d+\.\s+(?:\*\*|[A-Za-z]))/g;
  let match;
  while ((match = re.exec(text)) !== null) {
    const start = match.index + (match[0].length - match[1].length);
    if (!starts.includes(start)) starts.push(start);
  }
  return starts.sort((a, b) => a - b);
}

function findAnswerSplitIndex(text, maxChars) {
  if (text.length <= maxChars) return text.length;
  const window = text.slice(0, maxChars);
  const lastPara = window.lastIndexOf('\n\n');
  if (lastPara >= maxChars * 0.35) return lastPara;
  const lastLine = window.lastIndexOf('\n');
  if (lastLine >= maxChars * 0.45) return lastLine;
  const lastSentence = Math.max(
    window.lastIndexOf('. '),
    window.lastIndexOf('! '),
    window.lastIndexOf('? ')
  );
  if (lastSentence >= maxChars * 0.5) return lastSentence + 1;
  return maxChars;
}

function prependExtra(overflow, extra) {
  const tail = overflow?.trim();
  if (!tail) return extra?.trim() || '';
  const head = extra?.trim() || '';
  return head ? `${tail}\n\n${head}` : tail;
}

/**
 * Keeps answer short for library cards; moves long tails and extra sections into extraInfo.
 */
export function compactBulkAnswerFields(answer, extraInfo = '') {
  let ans = answer == null ? '' : String(answer).trim();
  let extra = extraInfo == null ? '' : String(extraInfo).trim();

  const sectionStarts = findNumberedSectionStarts(ans);
  if (sectionStarts.length > BULK_ANSWER_MAX_NUMBERED_SECTIONS) {
    const cut = sectionStarts[BULK_ANSWER_MAX_NUMBERED_SECTIONS];
    extra = prependExtra(ans.slice(cut), extra);
    ans = ans.slice(0, cut).trim();
  }

  if (ans.length > BULK_ANSWER_MAX_CHARS) {
    const idx = findAnswerSplitIndex(ans, BULK_ANSWER_MAX_CHARS);
    extra = prependExtra(ans.slice(idx), extra);
    ans = ans.slice(0, idx).trim();
  }

  return { answer: ans, extraInfo: extra };
}
